import { CancelTokenSource } from 'axios';
import { InterventionExternalCode } from 'ts-types/api.enums';
import { CompanyArticleGroupDto, CompanyDto, CompanySearchRequest, UpsertCompanyDto } from 'ts-types/api.types';
import axios from './http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/companies`;

export const getAllCompanies = (
    mandateId: number,
    source: CancelTokenSource): Promise<Array<CompanyDto>> => {

  return axios
      .get(apiUri, {params: {mandateId: mandateId}, cancelToken: source.token})
      .then(response => response.data);
};

export const getCompanies = (
    source: CancelTokenSource): Promise<Array<CompanyDto>> => {

  return axios
      .get(`${apiUri}/all`, {cancelToken: source.token})
      .then(response => response.data);
};


export const getAllGuarantorCompanies = (
    mandateId: number,
    source: CancelTokenSource): Promise<Array<CompanyDto>> => {

  return axios
      .get(`${apiUri}/guarantors`, {params: {mandateId: mandateId}, cancelToken: source.token})
      .then(response => response.data);
};

export const getAllGuarantors = (
    source: CancelTokenSource): Promise<Array<CompanyDto>> => {

  return axios
      .get(`${apiUri}/all/guarantors`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getCompanyArticleGroupsForCompany = (
    companyId: number, source: CancelTokenSource)
    : Promise<Array<CompanyArticleGroupDto>> => {

  return axios
      .get(`${apiUri}/article-groups/${companyId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getCompanyExternalCodeFromCompanyArticleGroups = (
    companyId: number, source: CancelTokenSource)
    : Promise<Array<InterventionExternalCode>> => {

  return axios
      .get(`${apiUri}/company-external-codes/${companyId}`, {cancelToken: source.token})
      .then(response => response.data);
};

export const getCompanyExternalCodeFromCompanyArticleGroupsWithCertificates = (
    companyId: number, source: CancelTokenSource)
    : Promise<Array<InterventionExternalCode>> => {

  return axios
      .get(
          `${apiUri}/company-external-codes-with-certificates/${companyId}`,
          {cancelToken: source.token})
      .then(response => response.data);
};

export const searchCompanies = (
    companySearchRequest: Partial<CompanySearchRequest>,
    source: CancelTokenSource)
    : Promise<Array<CompanyDto>> => {

  return axios
      .post(`${apiUri}/search`, companySearchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const getCompanyData = (companyId: number, source: CancelTokenSource): Promise<CompanyDto> => {
  return axios
      .get(`${apiUri}/company/${companyId}`, {cancelToken: source.token})
      .then((response) => response.data);
};

export const findCompanyById = (id: number, source: CancelTokenSource): Promise<UpsertCompanyDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const saveCompany = (
    upsertCompanyDto: Partial<UpsertCompanyDto>, source: CancelTokenSource)
    : Promise<CompanyDto> => {

  return axios
      .post(apiUri, upsertCompanyDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const editCompany = (
    id: number, upsertCompanyDto: Partial<UpsertCompanyDto>, source: CancelTokenSource)
    : Promise<CompanyDto> => {

  return axios
      .put(`${apiUri}/${id}`, upsertCompanyDto, {cancelToken: source.token})
      .then(response => response.data);
};

export const deleteCompany = (id: number, source: CancelTokenSource): Promise<CompanyDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};
